import { render, staticRenderFns } from "./alumno-listado.vue?vue&type=template&id=6e4af755&scoped=true&"
import script from "./alumno-listado.component.ts?vue&type=script&lang=ts&"
export * from "./alumno-listado.component.ts?vue&type=script&lang=ts&"
import style0 from "./alumno-listado.vue?vue&type=style&index=0&id=6e4af755&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4af755",
  null
  
)

export default component.exports